import React, { useState } from "react";
import Select from "react-select";
import styles from "./style/FInputt.module.scss";
import PhoneInput from "react-phone-input-2";
import { act } from "react-dom/test-utils";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/solid";
import { GiCancel } from "@react-icons/all-files/gi/GiCancel";
import { replace } from "lodash";

const FInputt = ({
  type = "text",
  title = null,
  name = "",
  maxLength = 100,
  placeholder = "placeholder",
  onChange = () => { },
  errors = "",
  value = null,
  options = [],
  selectedOption = "",
  border = "",
  onKeyDown = () => { },
  disabled = false,
  formik = null,
  action = () => { },
  onFocus = () => { },
  className = null,
  inputmode = null,
  keyboard = null,
}) => {
  const _setText = (value, inputName) => {
    setInputValue(value);
    formik.setFieldValue(inputName, value);
  };

  const [inputValue, setInputValue] = useState(!value ? "" : value);
  const [phoneNumber, setPhoneNumber] = useState(!value ? "" : value);
  const [passView, setPassView] = useState(true);
  // const [money,setMoney] = useState('$0.00')

  const setMoney = (value) => {
    let money = value.replace("$", "");
    if (!isNaN(money)) {
      return "$" + money;
    }
  };

  const dateMin = new Date();
  dateMin.setMonth(dateMin.getMonth() - 12 * 13);

  const [datePicker, setDatePicker] = useState("");
  // className="bg-backgroundInput w-full h-[63px] rounded-[12px] pl-4"

  const FSelectIcon = {
    control: (base, state) => ({
      ...base,
      // background: "#e3e0dd",
      height: "63px",
      margin: "10px 0px",
      border: "0px",
      fontWeight: "regular",
      backgroundColor: "#f6f6f6",
      borderRadius: "12px",
      paddingLeft: "7px",
      fontSize: "16px",
      width: "100%",
    }),
  };

  const dataIconPhone = [
    {
      value: "484",
      text: "México",
      iso: "MX",
    },
    {
      value: "840",
      text: "Estados Unidos",
      iso: "US",
    },
  ];

  // const dataSelectIcon = [
  //   {
  //     value: "484",
  //     text: "México",
  //     srcIco: require(`../FInput/images/MX.png`),
  //   },
  //   {
  //     value: "840",
  //     text: "Estados Unidos",
  //     srcIco: require(`../FInput/images/US.png`),
  //   },
  // ];

  const [selectIcon, setSelectIcon] = useState(
    !value ? "" : options.find((select) => select.value === value)
  );

  const [selectOption, setSelectOption] = useState(
    !value ? "" : options.find((select) => select.value === value)
  );

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  switch (type) {
    case "PhoneInput":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{!title ? "" : title}</div>
          <PhoneInput
            countryCodeEditable={false}
            name={name}
            type="text"
            country={"mx"}
            onlyCountries={["us", "mx", "co"]}
            value={value != null ? value : phoneNumber}
            onChange={(phone, country) => {
              setPhoneNumber(phone);
              let _data = null;
              let _phone = phone.substring(country.dialCode.length);

              if (!_phone) {
                _data = {
                  inalidate: true,
                  message: "Campo Requerido",
                  phone: "+" + phone,
                };
              } else {
                if (_phone.length < 10 && _phone.length > 0) {
                  _data = {
                    inalidate: true,
                    message: "minimo 10 caracteres",
                    phone: "+" + phone,
                  };
                } else {
                  _data = "+" + phone;
                }
              }

              formik.setFieldValue(name, _data);
            }}
            buttonStyle={{
              background: "#e4e4e4",
              border: !formik.errors.phoneNumber ? "0px" : "1px" + " solid red",
              paddingLeft: "10px",
              paddingRight: "10px",
              borderRadius: "12px 0px 0px 12px",
            }}
            inputStyle={{
              background: "#f8faf9",
              width: "95%",
              border: !formik.errors.phoneNumber ? "0px" : "1px" + " solid red",
              height: "60px",
              borderRadius: "12px",
              marginLeft: "20px",
            }}
          />
          <p className="text-error font-bold">{formik.errors[name]}</p>
        </div>
      );
    case "SelectIcon":
      return (
        <div className={styles.FButtonDiv}>
          <div className={classNames(styles.FInputTitle, "font-bold")}>
            {title}
          </div>{" "}
          <Select
            isSearchable={false}
            styles={FSelectIcon}
            placeholder={placeholder}
            value={selectIcon}
            options={options.length == 0 ? [] : options}
            onChange={(e) => {
              if (!onChange) {
                formik.setFieldValue(name, e.value);
                setSelectIcon(e);
              } else {
                formik.setFieldValue(name, e.value);
                setSelectIcon(e);
                formik.setFieldValue(name, e.value);
                onChange(e);
              }
            }}
            getOptionLabel={(e) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={e.srcIco} style={{ height: "23px" }} />
                &nbsp;
                <span style={{ marginLeft: 5 }}>{e.text}</span>
              </div>
            )}
          />
          <p className="text-red-500 font-bold">{errors}</p>
        </div>
      );
    case "Select":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <Select
            styles={FSelectIcon}
            placeholder={placeholder}
            value={selectedOption != "" ? selectedOption : options[0]}
            options={options.length == 0 ? dataIconPhone : options}
            onChange={onChange}
            getOptionLabel={(e) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginLeft: 5 }}>{e.text}</span>
              </div>
            )}
          />
          <p className="text-red-500 font-bold">{errors}</p>
        </div>
      );
    case "DatePicker":
      // formik.setFieldValue(name, formatDate(dateMin));

      return (
        <div className={styles.FButtonDiv}>
          <div className="font-bold text-[4.5vw] xxs:text-[14px] pb-1">{title}</div>
          <input
            type="date"
            value={datePicker}
            className={classNames(styles.FDatePicker, "py-[31px]")}
            onChange={(date) => {
              let _data = null;
              setDatePicker(date.target.value);
              const _date = new Date(date.target.value);
              _date.setDate(_date.getDate() + 1);
              _data = date.target.value;

              // if (!(dateMin > _date)) {
              //   _data = {
              //     inalidate: true,
              //     message: "edad mínima 13 años",
              //     password: date.target.value,
              //   };
              // } else {
              //   _data = date.target.value;
              // }

              formik.setFieldValue(name, _data);
              console.log(_data)
              onChange(_data);
            }}
            max={formatDate(dateMin)}
          />
          <p className="text-error font-bold text-left text-small">
            {formik.errors[name]}</p>
        </div>
      );
    case "botton":
      return (
        <input
          type={"button"}
          value={title}
          disabled={!disabled == null ? !disabled : null}
          className={
            className == null
              ? disabled == false
                ? "bg-primary px-4 w-full py-1 rounded-xl text-white hover:shadow-lg hover:shadow-primary/50"
                : "bg-colorDisabled w-full py-[6px] rounded-xl text-white"
              : className
          }
          onClick={onChange}
        />
      );
    case "submit":
      return (
        <button
          disabled={!formik.isValid}
          type={type}
          className={
            formik.isValid
              ? "bg-primary px-4 w-full rounded-[16px] font-regular text-[14px] py-[10px] text-white hover:shadow-lg hover:shadow-primary/50 "
              : "bg-colorDisabled w-full py-[10px] rounded-[16px] font-regular text-[14px] "
          }
        >
          {title}
        </button>
      );
    case "password":
      return (
        <div className={styles.FButtonDiv}>
          <div className="text-left text-small font-bold">{title}</div>
          <div className="flex justify-end items-center relative text-small">
            <input
              type={passView ? "password" : "text"}
              name={name}
              inputmode={inputmode == null ? "text" : inputmode}
              className="bg-backgroundInput w-full h-[63px] rounded-[12px] pl-4"
              maxLength={!maxLength ? 9999 : maxLength}
              placeholder={placeholder}
              onChange={(pass) => {
                let _data = null;
                let _password = pass.target.value;
                if (!onChange) {
                  // if (!_password) {
                  //   _data = {
                  //     inalidate: true,
                  //     message: "Campo Requerido",
                  //     data: _password,
                  //   };
                  // } else {
                  //   if (!checkPassword(_password)) {
                  //     _data = {
                  //       inalidate: true,
                  //       message:
                  //         "mínimo 6 caracteres, mayúsculas, minúsculas, símbolo y numeros",
                  //       data: _password,
                  //     };
                  //   } else {
                  //     _data = _password;
                  //   }
                  // }

                  formik.setFieldValue(name, _data);
                } else {
                  onChange(_password);
                }
              }}
            />
            {/* passView */}
            <div
              className="absolute mr-5 w-7"
              onClick={() => {
                setPassView(!passView);
              }}
            >
              <EyeIcon className={passView ? "" : "hidden"} />
              <EyeOffIcon className={!passView ? "" : "hidden"} />
            </div>
          </div>
          <p className="text-error text-left text-[13px] font-bold">
            {formik.errors[name]}
          </p>
        </div>
      );
    case "text":
      return (
        <div className={styles.FButtonDiv}>
          <div className={classNames(styles.FInputTitle, "font-bold")}>
            {title}
          </div>
          <input
            type={type}
            name={name}
            onFocus={onFocus}
            maxLength={maxLength}
            className="bg-backgroundInput w-full h-[63px] rounded-[12px] pl-4"
            disabled={disabled}
            value={inputValue}
            placeholder={placeholder}
            onChange={(e) => {
              _setText(e.target.value, name);
            }}
            re
            inputMode={keyboard != null ? keyboard : "text"}
            onKeyUp={onKeyDown}
          />
          <p className="text-error text-[13px] font-bold">
            {formik == null ? null : formik.errors[name]}
          </p>
        </div>
      );
    case "money":
      return (
        <div className={styles.FButtonDiv}>
          <div className={classNames(styles.FInputTitle, "font-bold")}>
            {title}
          </div>
          <input
            type={type}
            name={name}
            onFocus={onFocus}
            maxLength={maxLength}
            className="bg-backgroundInput w-full h-[63px] rounded-[12px] pl-4"
            disabled={disabled}
            value={setMoney(inputValue)}
            placeholder={placeholder}
            onChange={(e) => {
              _setText(e.target.value, name);
            }}
            inputMode={keyboard != null ? keyboard : "text"}
            onKeyUp={onKeyDown}
          />
          <p className="text-error text-[13px] font-bold">
            {formik == null ? null : formik.errors[name]}
          </p>
        </div>
      );
    case "textIcon":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <div className="flex justify-end items-center relative">
            <input
              type={"text"}
              name={name}
              className={classNames(
                styles.FInputText,
                !!errors ? "border-2" : "border-0",
                "border-red-500"
              )}
              value={value}
              maxLength={!maxLength ? 9999 : maxLength}
              placeholder={placeholder}
              onChange={(pass) => {
                let _data = null;
                let _password = pass.target.value;
                if (!onChange) {
                  if (!_password) {
                    _data = {
                      inalidate: true,
                      message: "Campo Requerido",
                      data: _password,
                    };
                  } else {
                    if (!checkPassword(_password)) {
                      _data = {
                        inalidate: true,
                        message:
                          "mínimo 6 caracteres, mayúsculas, minúsculas, símbolo y numeros",
                        data: _password,
                      };
                    } else {
                      _data = _password;
                    }
                  }

                  formik.setFieldValue(name, _data);
                } else {
                  onChange(_password);
                }
              }}
            />
            {/* passView */}
            <div
              className="absolute mr-5 w-7"
              onClick={() => {
                action();
              }}
            >
              <GiCancel className="text-xl" />
            </div>
          </div>
          <p className="text-error text-[13px] font-bold">
            {formik.errors[name]}
          </p>{" "}
        </div>
      );
    case "tel":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <input
            type={"tel"}
            name={name}
            maxLength={maxLength}
            className={
              className == null
                ? classNames(
                  styles.FInputText,
                  !!errors ? "border-2" : "border-0",
                  "border-red-500"
                )
                : className
            }
            value={value}
            style={{ border: border }}
            placeholder={placeholder}
            onChange={(e) => {
              if (e.target.value == "") {
                e.target.value = ""
              } else {
                let val = parseInt(e.target.value);
                if (isNaN(val)) {
                  e.target.value = ""
                } else {
                  onChange(e)
                }

              }
            }}
            onKeyUp={(e) => {
              if ("onKeyUp", e.target.value != "" || e.key.toLowerCase() === "backspace" ||
                e.key.toLowerCase() === "arrowleft") {
                onKeyDown(e)
              }
            }}
          />
          <p className="text-red-500 font-bold">{errors}</p>
        </div>
      );

    default:
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <input
            type={"tel"}
            name={name}
            maxLength={maxLength}
            className={
              className == null
                ? classNames(
                  styles.FInputText,
                  !!errors ? "border-2" : "border-0",
                  "border-red-500"
                )
                : className
            }
            value={value}
            style={{ border: border }}
            placeholder={placeholder}
            onChange={onChange}
            onKeyUp={onKeyDown}
          />
          <p className="text-red-500 font-bold">{errors}</p>
        </div>
      );
  }
};

function checkPassword(str) {
  //  min 6 a 15 letras, con al menos un símbolo, letras mayúsculas y minúsculas y un número
  var re =
    /^(?=.*\d)(?=.*[!@#$%^&*.=_\-()+<>:;°|¿?])(?=.*[a-z])(?=.*[A-Z]).{6,50}$/;
  return re.test(str);
}

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export default FInputt;
